import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiService } from 'src/services/apiService';

@Component({
  selector: 'app-reject-applications',
  standalone: false,
  providers:[
    MessageService 
  ],
  templateUrl: './reject-applications.component.html',
  styleUrls: ['./reject-applications.component.css']
})
export class RejectApplicationsComponent implements OnInit {

  requests: any[] = []; // قائمة الطلبات
  paginatedRequests: any[] = []; // بيانات مقسمة حسب الصفحات
  currentIndex = 1;
  totalPages = 1; // إجمالي الصفحات
  pageNumbers: number[] = Array.from({ length: this.totalPages }, (_, i) => i + 1); // لتوليد الأرقام
  natinoalId: string = "";
  establishName: string = "";
  establishType: string = "";
  mainPath = ""; // قراءة القيمة من environment
  previousMonth: string = '';
  previousYear: number = 0;
  isTestMode: boolean = false; // تفعيل وضع الاختبار
  isLoading: boolean = false; // حالة التحميل

  constructor(private apiService: ApiService,private messageService:MessageService) { }

  ngOnInit() {
    this.initialize();
  }

  private async initialize(): Promise<void> {
    this.mainPath = environment.MainPath;
    const { month, year } = this.getPreviousMonth(new Date());
    this.previousMonth = month;
    this.previousYear = year;

    await this.fillRequest(); // انتظار نتيجة الدالة
    this.paginateRequests(); // تقسيم البيانات حسب الصفحات
  }

  // دالة تحميل البيانات
  async fillRequest() {
    this.isLoading = true;  // بدء التحميل
    if (this.isTestMode) {
      // وضع الاختبار مع 20 سجل
      this.requests = [
        { id: 1, establishmentNatId: '123456789', companyName: 'شركة ABC', establishmentType: 'مقاولات' },
        { id: 2, establishmentNatId: '987654321', companyName: 'شركة XYZ', establishmentType: 'تكنولوجيا' },
        { id: 3, establishmentNatId: '112233445', companyName: 'شركة 123', establishmentType: 'صناعة' },
        { id: 4, establishmentNatId: '223344556', companyName: 'شركة 456', establishmentType: 'تجارة' },
        { id: 5, establishmentNatId: '334455667', companyName: 'شركة 789', establishmentType: 'خدمات' },
        { id: 6, establishmentNatId: '445566778', companyName: 'شركة 101', establishmentType: 'مقاولات' },
        { id: 7, establishmentNatId: '556677889', companyName: 'شركة 202', establishmentType: 'تكنولوجيا' },
        { id: 8, establishmentNatId: '667788990', companyName: 'شركة 303', establishmentType: 'صناعة' },
        { id: 9, establishmentNatId: '778899001', companyName: 'شركة 404', establishmentType: 'تجارة' },
        { id: 10, establishmentNatId: '889900112', companyName: 'شركة 505', establishmentType: 'خدمات' },
        { id: 11, establishmentNatId: '990011223', companyName: 'شركة 606', establishmentType: 'مقاولات' },
        { id: 12, establishmentNatId: '100122334', companyName: 'شركة 707', establishmentType: 'تكنولوجيا' },
        { id: 13, establishmentNatId: '200233445', companyName: 'شركة 808', establishmentType: 'صناعة' },
        { id: 14, establishmentNatId: '300344556', companyName: 'شركة 909', establishmentType: 'تجارة' },
        { id: 15, establishmentNatId: '400455667', companyName: 'شركة 010', establishmentType: 'خدمات' },
        { id: 16, establishmentNatId: '500566778', companyName: 'شركة 111', establishmentType: 'مقاولات' },
        { id: 17, establishmentNatId: '600677889', companyName: 'شركة 222', establishmentType: 'تكنولوجيا' },
        { id: 18, establishmentNatId: '700788990', companyName: 'شركة 333', establishmentType: 'صناعة' },
        { id: 19, establishmentNatId: '800899001', companyName: 'شركة 444', establishmentType: 'تجارة' },
        { id: 20, establishmentNatId: '900900112', companyName: 'شركة 555', establishmentType: 'خدمات' }
      ];
    } else {
      // استدعاء الخدمة الفعلية
      try {
        const request = this.apiService.get('OFDC/LastMonthListApplications');
        const response = await firstValueFrom(request);

        this.requests = response.data as any[];
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }
    this.isLoading = false; // إيقاف التحميل
    this.paginateRequests();
  }

  // دالة لتقسيم البيانات حسب الصفحات
  paginateRequests() {
    const pageSize = 10;
    const totalItems = this.requests.length;
    this.totalPages = Math.ceil(totalItems / pageSize);
    const startIndex = (this.currentIndex - 1) * pageSize;
    const endIndex = startIndex + pageSize;

    this.paginatedRequests = this.requests.slice(startIndex, endIndex);

    // Generate an array of page numbers to use in *ngFor
    this.pageNumbers = Array.from({ length: this.totalPages }, (_, index) => index + 1);
  }

  // الانتقال إلى الصفحة التالية
  nextPage() {
    if (this.currentIndex < this.totalPages) {
      this.currentIndex++;
      this.paginateRequests();
    }
  }

  // الانتقال إلى الصفحة السابقة
  previousPage() {
    if (this.currentIndex > 1) {
      this.currentIndex--;
      this.paginateRequests();
    }
  }

  goToPage(page: number): void {
    this.currentIndex = page;
    this.paginateRequests();
  }

  // دالة لحساب الشهر والسنة للشهر الماضي
  getPreviousMonth(date: Date): { month: string; year: number } {
    const currentMonth = date.getMonth() + 1; // الشهر الحالي (1-12)
    const currentYear = date.getFullYear();

    if (currentMonth === 1) {
      // إذا كان الشهر الحالي يناير، الشهر الماضي هو ديسمبر من السنة السابقة
      return { month: '12', year: currentYear - 1 };
    } else {
      // الشهر الماضي عادي
      return {
        month: (currentMonth - 1).toString().padStart(2, '0'), // تحويل إلى صيغة 01-12
        year: currentYear,
      };
    }
  }

  deleteRequest(index: number): void {

    if(confirm("هل انت متأكد")) {

      // حذف العنصر من paginatedRequests
      const deletedRequest = this.paginatedRequests[index];  // تخزين الطلب الذي سيتم حذفه
    
      // استدعاء API لإلغاء الطلب
      const cancelRequestPayload = {
        carbonCobyId: [deletedRequest.carbonId],  // أو أي معرّف آخر من الكائن المحذوف
        cancelReason: `تم الغاء طلبك في خدمة "طلب السداد المبكر الحطيطة" نظرا لانتهاء الشهر`
      };
    
      this.apiService.post('carboncopies/CancelCarbonCopies', cancelRequestPayload)
        .subscribe(
          cancelResponse => {

            if(cancelResponse.statusCode==200){

            // بعد الإلغاء بنجاح، نقوم بإرسال الطلب الثاني
            const finishRequestPayload = {
              applicationNumber: deletedRequest.applicationNumber,
              carbonId: deletedRequest.carbonId // أو أي قيمة أخرى مناسبة حسب البيانات المتوفرة
            };
    
            this.apiService.post('OFDC/FinishApplication', finishRequestPayload)
              .subscribe(
                finishResponse => {

                  if(finishResponse.statusCode=200){

                    this.messageService.add({ severity: 'success', summary: "نجاح", detail: 'تم الغاء الطلب بنجاح' });

                    this.paginatedRequests.splice(index, 1);
                    this.requests.splice(index, 1);  
                    // إعادة تحديث البيانات (إن كانت بحاجة لذلك)
                    this.paginateRequests();
                  }
                },
                error => {
                  // التعامل مع الخطأ في حال فشل الطلب الثاني
                  console.error('Error finishing request', error);
                }
                
              );
        
            }
    
          },
          cancelError => {
            // التعامل مع الخطأ في حال فشل الطلب الأول
            console.error('Error cancelling request', cancelError);
          }
        );
    
      // إعادة ترتيب الصفحات بعد حذف العنصر
      this.paginateRequests();


    }

  }
  
}
